"use client";

import { ContentfulImage } from "@2u-landing-pages/components/ContentfulImage";
import { ContentLayout } from "@2u-landing-pages/components/ContentLayout";
import {
  ContentfulImageConfig,
  TypeContent_fullWithoutUnresolvableLinksResponse,
  TypeProgram_metaWithoutUnresolvableLinksResponse,
} from "@2u-landing-pages/types";
import { useMetadataParser } from "@2u-landing-pages/utils/useMetadataParser";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import cn from "classnames";
import { forwardRef } from "react";
import { ProductCardProps } from "../../ProductCard.type";
import { Default as DefaultProductCard } from "../Default";
// import { camelCase, generateId, useIntersectionObserver } from "@2u-landing-pages/utils";
// @ts-ignore
import styles from "./Extended.module.scss";

export const Extended = forwardRef<HTMLDivElement, ProductCardProps>(
  ({ product, index = 0, currentPage, lob, category, position, mode, className, standalone }, ref) => {
    const inspector = useContentfulInspectorMode();

    const { program_meta, product_card_id, school_photo, school_photo_config, extended_card_content } =
      product?.fields || {};

    const { fields: programMeta, parseMetadata } = useMetadataParser(
      program_meta as TypeProgram_metaWithoutUnresolvableLinksResponse
    );

    return (
      <div className={cn(styles.extendedProductCardWrapper, className)}>
        <div
          id={product_card_id || `product-card-${product?.sys?.id || ""}`}
          data-name={parseMetadata(`${programMeta?.school_name} - ${programMeta?.program_name}`)}
          className={cn(styles.productCard)}
        >
          {school_photo?.fields?.file?.url && (
            <div className={styles.featuredImage}>
              <ContentfulImage
                key={`school-photo-${product?.sys?.id || ""}`}
                image={school_photo}
                config={school_photo_config as unknown as ContentfulImageConfig}
                loading="eager"
                {...inspector({
                  entryId: product?.sys?.id || "",
                  fieldId: "school_photo",
                })}
              />
            </div>
          )}
          <main className={styles.contentContainer}>
            <aside className={styles.extendedContent}>
              {extended_card_content && (
                <ContentLayout
                  content={extended_card_content as TypeContent_fullWithoutUnresolvableLinksResponse}
                />
              )}
            </aside>
            <div className={styles.productCardContainer}>
              <DefaultProductCard
                product={product}
                index={index}
                currentPage={currentPage}
                lob={lob}
                category={category}
                position={position}
                ref={ref}
                extended={true}
                mode={mode}
                standalone={standalone}
              />
            </div>
          </main>
        </div>
      </div>
    );
  }
);

Extended.displayName = "Extended";
